import { Dataset } from 'generic/dataset'

export const refreshCommunityConfigurations = (communityIdentifier: string): Promise<any> => {
  const params = [{param: 'forceRefresh', value: true}]
  return new Dataset().loadCommunityDataset('communityConfiguration', communityIdentifier, params)
  .then((configuration) => {
    return configuration
  })
}